import SeoHead from "@/Component/Seo/SeoHead";
import SeasonalDeals from "@/Component/Module/SeasonalDeals";
import {
  serverFetchReviewsList,
  serverFetchSeasonalDealsData,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { stripHtml } from "@/utils/dealsHelpers";
import { renderNotFoundPage } from "@/utils/detailSlug";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function SeasonalDealsPage({
  seo,
  seoCountry,
  slug,
  initialSeasonalDealsData,
  initialReviewsList,
}) {
  const fallbackTitle =
    initialSeasonalDealsData?.pageTitle ||
    stripHtml(initialSeasonalDealsData?.heading?.title) ||
    "Seasonal Deals";

  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle={`${fallbackTitle} | Next Holidays`} />
      <SeasonalDeals
        slug={slug}
        initialSeasonalDealsData={initialSeasonalDealsData}
        initialReviewsList={initialReviewsList}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const slugParam = context.params?.slug;
  const slug = Array.isArray(slugParam) ? slugParam[0] : slugParam;

  if (!slug) {
    return renderNotFoundPage(context);
  }

  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const [dealsResponse, reviewsResponse] = await Promise.all([
      serverFetchSeasonalDealsData(slug, country),
      serverFetchReviewsList({ moduleType: "SeasonalDealsPage", slug }, country),
    ]);

    const dealsData = dealsResponse?.data || null;
    if (
      String(dealsResponse?.status || "").toLowerCase() === "error" ||
      !dealsData
    ) {
      return renderNotFoundPage(context);
    }

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        slug,
        initialSeasonalDealsData: dealsData,
        initialReviewsList: reviewsResponse?.data || null,
      },
    };
  } catch (error) {
    console.error("Seasonal deals page SSR error:", error);
    return renderNotFoundPage(context);
  }
}
